import "@/App.css";
import { ReactLenis, useLenis } from "lenis/react";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import BrandMarquee from "./components/BrandMarquee";
import BigIdea from "./components/BigIdea";
import WhoWeHelp from "./components/WhoWeHelp";
import Calculator from "./components/Calculator";
import WhySkope from "./components/WhySkope";
import StartWithSkope from "./components/StartWithSkope";
import Services from "./components/Services";
import HowWeWork from "./components/HowWeWork";
import Philosophy from "./components/Philosophy";
import Proof from "./components/Proof";
import FinalCTA from "./components/FinalCTA";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CursorGlow from "./components/CursorGlow";
import WhatsAppButton from "./components/WhatsAppButton";
import AdminPage from "./components/AdminPage";
import AdminLogin from "./components/AdminLogin";
import AdminResetPassword from "./components/AdminResetPassword";
import BlogIndex from "./components/BlogIndex";
import MigratedPage from "./components/MigratedPage";
import FAQPage from "./components/FAQPage";
import AboutPage from "./components/AboutPage";
import TermsPage from "./components/TermsPage";
import FAQSection from "./components/FAQSection";
import Locations from "./components/Locations";
import BrandsPage from "./components/BrandsPage";
import { HOME_FAQS } from "./lib/faqData";
import SchedulePage, { ScheduleModal } from "./components/ScheduleCall";

const Home = () => {
  const location = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => lenis?.scrollTo(location.hash, { offset: -64, duration: 1.2 }), 500);
      return () => clearTimeout(t);
    }
  }, [location.hash, lenis]);
  return (
  <div className="bg-white text-ink font-body antialiased">
    <CursorGlow />
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <BrandMarquee />
      <BigIdea />
      <WhoWeHelp />
      <Calculator />
      <WhySkope />
      <StartWithSkope />
      <Services />
      <HowWeWork />
      <Philosophy />
      <Proof />
      <Locations />
      <FAQSection faqs={HOME_FAQS} idPrefix="home-faq" source="home" />
      <FinalCTA />
      <Contact />
    </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 1, touchMultiplier: 1.4 }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/schedule-a-call" element={<SchedulePage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/our-brands" element={<BrandsPage />} />
          <Route path="/terms-con." element={<TermsPage />} />
          <Route path="/terms-con" element={<TermsPage />} />
          <Route path="*" element={<MigratedPage />} />
        </Routes>
        <ScheduleModal />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </ReactLenis>
  );
}

export default App;
